import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'atom-chapter-price',
  imports: [],
  templateUrl: './chapter-price.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChapterPriceAtom implements OnInit {
  @Input() value = 'Miễn phí';
  constructor() {}

  ngOnInit(): void {}
}
